import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCOgvKznBawHAi4ttHWDN9DU3J5jg6A1lA",
  authDomain: "meta-invoice-app.firebaseapp.com",
  projectId: "meta-invoice-app",
  storageBucket: "meta-invoice-app.appspot.com",
  messagingSenderId: "133104091517",
  appId: "1:133104091517:web:bed691874e796fcd93cc14",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
